<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li class="current"><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->
        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong>支払い方法の入力</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <Cards ref="cards" :currentCards="cards" :defaultCardEnabled="true" @infoClick="$emit('openAlertModal', $event)"></Cards>
                    <p class="submit_btn">
                        <input type="submit" value="この方法で支払う" onsubmit="return false;" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>

                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
import Cards from "../../../../../../../WebApp/Commons/components/Cards.vue";

export default {
    components: {
        Cards
    },
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "ContractConfirm") {
            next({ name: "Top" });
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        const paramsCopy = JSON.parse(JSON.stringify(this.params));
        for (const entry of Object.entries(paramsCopy)) {
            to.params[entry[0]] = entry[1];
        }

        next();
    },
    methods: {
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        },
        checkDeliveryDate: async function () {
            return new Promise((resolve) => {
                const prefecture = this.params.customerPrefecture;
                const city = this.params.customerCity + this.params.customerAddress;

                this.$axios(
                    "POST",
                    "/payment/deliveryInfo",
                    {
                        prefecture: prefecture,
                        city: city
                    },
                    (res) => {
                        const deliveryDates = res.data.deliveryDates;
                        // 選択した日付が含まれるかチェックする
                        if (!deliveryDates[this.params.deliveryDate]) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                );
            });
        },
        confirm: function () {
            this.$emit(
                "openConfirmYesModal",
                "この内容で支払いをしてもよろしいですか？ボタン押下後はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。",
                async () => {
                    await this.setup();
                },
                () => {
                    // いいえの場合は処理しない
                    return;
                }
            );
        },
        setup: function () {
            this.$emit("showSpinner", "処理中です。処理中はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。");
            this.$axios("POST", "/payment/init", {}, async (res) => {
                this.setupClientSecret = res.data.setupClientSecret;
                try {
                    const res = await this.$refs.cards.cardSetup(this.setupClientSecret);
                    this.setupIntent = res.setupIntent;
                    this.isNewCardSelected = res.isNewCardSelected;
                    this.checkAndCompleteContract();
                } catch (err) {
                    this.$emit("hideSpinner");
                    this.$emit("openAlertModal", err.message, null);
                }
            });
        },

        checkAndCompleteContract: async function () {
            // プリペイドカードチェック
            this.$axios(
                "POST",
                "/payment/checkNonPrepaidCard",
                { setupIntent: this.setupIntent },
                // eslint-disable-next-line no-unused-vars
                async (res) => {
                    // 配送指定時間帯 日時チェック
                    if (await this.checkDeliveryDate()) {
                        try {
                            this.complete();
                        } catch (err) {
                            // ここに入るケースが思い当たらないがエモサブスク契約をまねる（あと仮にこのcatchに入ったとしたらSpinnerは消すのが正しいはず）
                            this.$emit("hideSpinner");
                            this.$emit("openAlertModal", err.message, null);
                        }
                    } else {
                        this.$emit("openAlertModal", "配送可能日が変更されました。配送可能日を変更してください。", () => {
                            this.$router.push({
                                name: "SetupEmoForm"
                            });
                        });
                    }
                },
                (err) => {
                    // カードがプリペイドカードかつ新規登録カードだった場合は支払い方法を削除する
                    if (this.isNewCardSelected) {
                        this.$axios(
                            "POST",
                            "/payment/deletePaymentMethod",
                            {
                                paymentMethod: this.setupIntent.payment_method
                            },
                            // eslint-disable-next-line no-unused-vars
                            (res) => {
                                this.$defaultErrorCallback(err);
                            }
                        );
                    } else {
                        this.$defaultErrorCallback(err);
                    }
                }
            );
        },
        complete: async function () {
            const isDefaultSet = this.$refs.cards.isDefaultSet();
            // 配送指定時間帯 日時チェック
            // 3Dセキュア認証中に配送日時が切り替わった場合を考慮し、不正な日時で配送されないために二重でチェックする
            if (await this.checkDeliveryDate()) {
                this.$axios(
                    "POST",
                    "/payment/subscription",
                    {
                        customer: {
                            email: this.params.customerEmail,
                            name: this.params.customerName,
                            kana: this.params.customerKana,
                            ageGroup: this.params.ownerAgeGroup,
                            gender: this.params.ownerGender,
                            postalCode: this.params.customerPostalCode,
                            prefecture: this.params.customerPrefecture,
                            city: this.params.customerCity,
                            address: this.params.customerAddress,
                            tel: this.params.customerTel
                        },
                        destination: {
                            name: this.params.copyAddress ? this.params.customerName : this.params.destinationName,
                            kana: this.params.copyAddress ? this.params.customerKana : this.params.destinationKana,
                            postalCode: this.params.copyAddress ? this.params.customerPostalCode : this.params.destinationPostalCode,
                            prefecture: this.params.copyAddress ? this.params.customerPrefecture : this.params.destinationPrefecture,
                            city: this.params.copyAddress ? this.params.customerCity : this.params.destinationCity,
                            address: this.params.copyAddress ? this.params.customerAddress : this.params.destinationAddress,
                            tel: this.params.copyAddress ? this.params.customerTel : this.params.destinationTel
                        },
                        setupIntent: this.setupIntent,
                        isDefaultSet: isDefaultSet,

                        product: this.params.product,
                        productId: document.productId,
                        planId: this.params.planId,
                        code: this.params.code,
                        promotionCode: this.params.promotionCode,
                        monthAmount: this.params.monthAmount,
                        durationInMonths: this.params.durationInMonths,

                        ownerGender: this.params.ownerGenderLabel,
                        ownerPrefecture: this.params.ownerPrefecture,
                        ownerArea: this.params.ownerArea,
                        emoPersonality: this.params.emoPersonality,
                        emoUserName: this.params.emoUserNameText || this.params.emoUserName,
                        emoUserAgeGroup: this.params.emoUserAgeGroup,
                        emoUserGender: this.params.emoUserGenderLabel,
                        emoPrefecture: this.params.emoPrefecture,
                        emoArea: this.params.emoArea,
                        emoUserRelationship: this.params.emoUserRelationship,
                        emoUserRelationshipText: this.params.emoUserRelationshipText,
                        firstMessage: this.params.firstMessage,

                        ownerAnswer1: this.params.ownerAnswer1,
                        ownerAnswer1SubAnswer: this.params.ownerAnswer1SubAnswer,
                        ownerAnswer1Text: this.params.ownerAnswer1Text,

                        np: document.np,

                        deliveryDate: this.params.deliveryDate,
                        deliveryTime: this.params.deliveryTime,

                        emoUserUuid: this.params.emoUserUuid
                    },
                    (res) => {
                        this.$emit("hideSpinner");
                        // 申し込みフォーム画面へ遷移
                        this.params.invoice = res.data.invoice;
                        this.params.affiliatePath = res.data.affiliatePath;
                        this.$router.push({
                            name: "ContractComplete"
                        });
                    }
                );
            } else {
                this.$emit("openAlertModal", "配送可能日が変更されました。配送可能日を変更してください。", () => {
                    this.$router.push({
                        name: "SetupEmoForm"
                    });
                });
            }
        }
    },

    data: function () {
        return {
            params: {},
            cards: [],
            promotionCode: {},
            payButtonEnabled: true,
            setupIntent: undefined,
            setupClientSecret: "",
            isNewCardSelected: false
        };
    },
    created() {
        this.params = this.$route.params;
        this.cards = this.$route.params.cards;
        this.promotionCode = this.$route.params.promotionCode;
    }
};
</script>

<style scoped>
/* iosで青字になる  */
select {
    color: #000000;
}
</style>
